import React, { memo } from "react";
import { Tag, Typography } from "antd";
import {
  CheckCircleOutlined,
  DollarOutlined,
  InfoCircleOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";

const { Text } = Typography;

const SimulationOverviewGuide = memo(function SimulationOverviewGuide({
  selectedFlightModel,
}) {
  return (
    <div className="box_wraper_div playground_overview_card">
      <div className="playground_card_header">
        <div className="playground_card_header_left">
          <Text className="playground_card_title">Live Overview & Guide</Text>
          <Text className="playground_card_subtitle">
            Active fleet baseline parameters & simulation workflow
          </Text>
        </div>
        <Tag color="blue" className="playground_model_tag">
          {selectedFlightModel || "Live Model"}
        </Tag>
      </div>

      {/* Simulation Principles & Guidelines (Three Static Cards) */}
      <div className="playground_overview_stats">
        <div className="playground_stat_box">
          <div className="playground_principle_top">
            <span className="playground_stat_label">SAFETY & ISOLATION</span>
            <SafetyCertificateOutlined
              style={{ color: "#2563eb", fontSize: "15px" }}
            />
          </div>
          <span className="playground_stat_val">Isolated Sandbox</span>
          <span className="playground_stat_sub">
            Experiment with proposed values in a separate workspace.
            Hypothetical changes remain isolated without altering production rankings.
          </span>
        </div>

        <div className="playground_stat_box">
          <div className="playground_principle_top">
            <span className="playground_stat_label">SIMULATION & INSIGHT</span>
            <DollarOutlined
              style={{ color: "#7c3aed", fontSize: "15px" }}
            />
          </div>
          <span className="playground_stat_val">Preview Impact</span>
          <span className="playground_stat_sub">
            Compare current and proposed scenarios side by side before deciding.
          </span>
        </div>

        <div className="playground_stat_box">
          <div className="playground_principle_top">
            <span className="playground_stat_label">GOVERNANCE</span>
            <CheckCircleOutlined
              style={{ color: "#059669", fontSize: "15px" }}
            />
          </div>
          <span className="playground_stat_val">Safe Application</span>
          <span className="playground_stat_sub">
            Live configuration updates only when you explicitly confirm Apply Changes.
            Every applied change is recorded in History.
          </span>
        </div>
      </div>

      {/* Simulation Workflow Steps */}
      <div className="playground_guide_section">
        <div className="playground_guide_heading">
          <InfoCircleOutlined style={{ color: "#2563eb", marginRight: 6 }} />
          <span>How Proposed Simulation Works</span>
        </div>

        <div className="playground_guide_steps">
          <div className="playground_guide_step">
            <div className="playground_step_num">1</div>
            <div className="playground_step_text">
              <Text strong className="playground_step_title">
                Enter Hypothetical Values
              </Text>
              <Text className="playground_step_desc">
                Click "Edit Proposed Values" to adjust fleet size, daily utilization, cycles, or labor rates.
              </Text>
            </div>
          </div>

          <div className="playground_guide_step">
            <div className="playground_step_num">2</div>
            <div className="playground_step_text">
              <Text strong className="playground_step_title">
                Run Simulation
              </Text>
              <Text className="playground_step_desc">
                Click "Run Simulation" to compute rank movement and total labor cost variance.
              </Text>
            </div>
          </div>

          <div className="playground_guide_step">
            <div className="playground_step_num">3</div>
            <div className="playground_step_text">
              <Text strong className="playground_step_title">
                Review & Apply
              </Text>
              <Text className="playground_step_desc">
                Changes stay isolated in this playground until you explicitly choose "Apply Changes".
              </Text>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default SimulationOverviewGuide;
